import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import User from '../views/sys/User.vue'
import Role from '../views/sys/Role.vue'
import Menu from '../views/sys/Menu.vue'

import axios from "../axios";
import store from "../store"
import el from "element-ui/src/locale/lang/el";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
      children: [
          {
            path: '/index',
            name: 'Index',
            meta: { title: "首页" },
            component: Index
          },
          {
            path: '/uxm/schedule',
            name: 'Schedule',
            meta: { title: '任务管理' },
            component: () => import('@/views/uxm/Schedule.vue')
          },
          {
            path: '/uxm/scheduleLog',
            name: 'ScheduleLog',
            meta: { title: '任务日志' },
            component: () => import('@/views/uxm/Schedule-log.vue')
          },
          {
            path: '/uxm/organize',
            name: 'Organize',
            meta: { title: '组织列表' },
            component: () => import('@/views/uxm/Organize.vue')
          },
          {
            path: '/uxm/user',
            name: 'UxmUser',
            meta: { title: '用户列表' },
            component: () => import('@/views/uxm/User.vue')
          },
          {
            path: '/uxm/order',
            name: 'UxmOrder',
            meta: { title: '订单列表' },
            component: () => import('@/views/uxm/Order.vue')
          },
          {
            path: '/uxm/payment',
            name: 'UxmPayment',
            meta: { title: '支付记录' },
            component: () => import('@/views/uxm/Payment.vue')
          },
          {
            path: '/uxm/product',
            name: 'UxmProduct',
            meta: { title: '产品管理' },
            component: () => import('@/views/uxm/Product.vue')
          },
			{
				path: '/userCenter',
				name: 'UserCenter',
				meta: {
					title: "个人中心"
				},
				component: () => import('@/views/UserCenter.vue')
			},
            {
            	path: '/sys/users',
            	name: 'SysUser',
            	meta: { title: '系统用户' },
            	component: User
            },
            {
            	path: '/sys/roles',
            	name: 'SysRole',
            	meta: { title: '系统角色' },
            	component: Role
            },
            {
            	path: '/sys/menus',
            	name: 'SysMenu',
            	meta: { title: '系统菜单' },
            	component: Menu
            },
		]
	},

	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/Login.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 辅助函数：深拷贝路由配置
const deepCloneRoutes = (routes) => {
	return routes.map(route => {
		const clonedRoute = {
			...route,
			children: route.children ? deepCloneRoutes(route.children) : undefined
		}
		// 保持component引用不变（函数引用不需要深拷贝）
		if (route.component) {
			clonedRoute.component = route.component
		}
		return clonedRoute
	})
}

// 辅助函数：检查路由是否已存在
const routeExists = (routes, targetPath, targetName) => {
	for (const route of routes) {
		if (route.path === targetPath || route.name === targetName) {
			return true
		}
		if (route.children && routeExists(route.children, targetPath, targetName)) {
			return true
		}
	}
	return false
}

router.beforeEach((to, from, next) => {

	let hasRoute = store.state.menus.hasRoutes

	let token = localStorage.getItem("token")

	if (to.path == '/login') {
		next()

	} else if (!token) {
		next({path: '/login'})


	} else if(token && !hasRoute) {
		axios.get("/sys/menu/nav", {
			headers: {
				Authorization: localStorage.getItem("token")
			}
		}).then(res => {
			// 防止空指针异常：检查响应数据是否存在
			if (res && res.data && res.data.data) {
				console.log(res.data.data)

				// 拿到menuList
				if (res.data.data.nav) {
					store.commit("setMenuList", res.data.data.nav)
				}

				// 拿到用户权限
				if (res.data.data.authoritys) {
					store.commit("setPermList", res.data.data.authoritys)
				}

				console.log(store.state.menus.menuList)

				const list = store.state.menus.menuList || []
				let exists = false
				for (let i = 0; i < list.length; i++) {
					const children = list[i].children || []
					for (let j = 0; j < children.length; j++) {
						if (children[j].path === '/uxm/organize') { exists = true; break }
					}
					if (exists) break
				}
				if (!exists) {
					const organizeMenu = {
						name: 'organizeRoot',
						title: '组织管理',
						icon: 'el-icon-office-building',
						children: [
							{ name: 'Organize', path: '/uxm/organize', title: '组织列表', icon: 'el-icon-user' }
						]
					}
					let insertIndex = list.findIndex(m => m.title === '用户管理')
					if (insertIndex >= 0) {
						list.splice(insertIndex + 1, 0, organizeMenu)
					} else {
						list.push(organizeMenu)
					}
					// 补充默认图标
					const defaultIcons = {
						'用户管理': 'el-icon-user',
						'订单管理': 'el-icon-document',
						'组织管理': 'el-icon-office-building',
						'系统管理': 'el-icon-setting'
					}
                    list.forEach(group => {
                        if (!group.icon && defaultIcons[group.title]) { group.icon = defaultIcons[group.title]; }
                        (group.children || []).forEach(item => {
                            if (!item.icon && defaultIcons[item.title]) { item.icon = defaultIcons[item.title]; }
                        });
                    });
					store.commit('setMenuList', list)
				}

				// 动态绑定路由 - 使用深拷贝避免修改原始路由配置
				const baseRoutes = deepCloneRoutes(router.options.routes)
				const homeRoute = baseRoutes.find(r => r.path === '/' && r.name === 'Home')
				
				if (homeRoute && res.data.data.nav && Array.isArray(res.data.data.nav)) {
					res.data.data.nav.forEach(menu => {
						if (menu.children) {
							menu.children.forEach(e => {
								// 转成路由
								let route = menuToRoute(e)

								// 检查路由是否已存在，避免重复添加
								if (route && homeRoute.children) {
									const exists = routeExists(homeRoute.children, route.path, route.name)
									if (!exists) {
										homeRoute.children.push(route)
									} else {
										console.warn(`路由已存在，跳过添加: ${route.path} (${route.name})`)
									}
								}
							})
						}
					})
				}

				console.log("newRoutes")
				console.log(baseRoutes)
				
				// 添加路由
				router.addRoutes(baseRoutes)

				hasRoute = true
				store.commit("changeRouteStatus", hasRoute)
				
				// 重要：路由添加完成后，重新导航到目标路由，确保路由匹配正确
				next(to)
			} else {
				// 响应数据为空的情况处理
				console.warn('获取菜单响应数据为空')
				hasRoute = true
				store.commit("changeRouteStatus", hasRoute)
				next(to)
			}
		}).catch(error => {
			// 错误处理：如果获取菜单失败，仍然允许访问首页
			console.error('获取菜单失败:', error)
			hasRoute = true
			store.commit("changeRouteStatus", hasRoute)
			// 重要：即使获取菜单失败，也要调用next()继续路由导航，避免页面卡住
			next(to)
		})
	} else if (token && hasRoute) {
		// 如果已经有路由，直接继续
		next()
	} else {
		// 其他情况，继续路由导航
		next()
	}
})


// 导航转成路由
const menuToRoute = (menu) => {

    if (!menu.component) {
        return null
    }

    let route = {
        name: menu.name,
        path: (menu.path && menu.path.startsWith('/')) ? menu.path : ('/' + (menu.path || '')),
        meta: {
            icon: menu.icon,
            title: menu.title
        }
    }
    route.component = () => import('@/views/' + menu.component +'.vue').catch(() => import('@/views/NotFound.vue'))

    return route
}

export default router
